var map = {
	"./DarkBlue0000.png": 1058,
	"./DarkBlue0001.png": 1059,
	"./DarkBlue0002.png": 1060,
	"./DarkBlue0003.png": 1061,
	"./DarkBlue0004.png": 1062,
	"./DarkBlue0005.png": 1063,
	"./DarkBlue0006.png": 1064,
	"./DarkBlue0007.png": 1065,
	"./Green0000.png": 1066,
	"./Green0001.png": 1067,
	"./Green0002.png": 1068,
	"./Green0003.png": 1069,
	"./Green0004.png": 1070,
	"./Green0005.png": 1071,
	"./Green0006.png": 1072,
	"./Green0007.png": 1073,
	"./LightBlue0000.png": 1074,
	"./LightBlue0001.png": 1075,
	"./LightBlue0002.png": 1076,
	"./LightBlue0003.png": 1077,
	"./LightBlue0004.png": 1078,
	"./LightBlue0005.png": 1079,
	"./LightBlue0006.png": 1080,
	"./LightBlue0007.png": 1081,
	"./Red0000.png": 1082,
	"./Red0001.png": 1083,
	"./Red0002.png": 1084,
	"./Red0003.png": 1085,
	"./Red0004.png": 1086,
	"./Red0005.png": 1087,
	"./Red0006.png": 1088,
	"./Red0007.png": 1089,
	"./White0000.png": 1090,
	"./White0001.png": 1091,
	"./White0002.png": 1092,
	"./White0003.png": 1093,
	"./White0004.png": 1094,
	"./White0005.png": 1095,
	"./White0006.png": 1096,
	"./White0007.png": 1097,
	"./Yellow0000.png": 1098,
	"./Yellow0001.png": 1099,
	"./Yellow0002.png": 1100,
	"./Yellow0003.png": 1101,
	"./Yellow0004.png": 1102,
	"./Yellow0005.png": 1103,
	"./Yellow0006.png": 1104,
	"./Yellow0007.png": 1105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1057;